var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body p-2" }, [
      _c(
        "div",
        { staticClass: "w-100 d-flex flex-row pb-2 align-items-baseline" },
        [
          _c("span", { staticClass: "flex-grow-1" }, [
            _vm._v(
              _vm._s(_vm.selectedCard && _vm.selectedCard.name) +
                " - " +
                _vm._s(_vm.startTime)
            )
          ]),
          _vm._v(" "),
          _c("label", [_vm._v(_vm._s(_vm.$t("kanbanComment")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml-2 input-group", staticStyle: { width: "33%" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.comment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.comment = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: {
                      click: function($event) {
                        _vm.comment = ""
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "visible",
              rawName: "v-visible",
              value: _vm.selectedCard,
              expression: "selectedCard"
            }
          ],
          staticClass: "w-100 d-flex flex-row"
        },
        [
          _c(
            "span",
            {
              staticClass: "flex-grow-1 text-center font-weight-bold",
              staticStyle: { "font-size": "3em" }
            },
            [_vm._v(_vm._s(_vm.totalDuration))]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("CenterOnParent", [
                _c(
                  "button",
                  { staticClass: "btn btn-primary", on: { click: _vm.start } },
                  [_c("i", { staticClass: "fa fa-play" })]
                )
              ])
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }